import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
  {
    q: "How does HousyHunt manage rental property for NRI or outstation owners?",
    a: "We assign a dedicated Property Relationship Manager who handles the entire lifecycle: high-resolution photography, tenant marketing, extensive KYC/police verification, rental agreement execution, automated rent collection to your account, and quarterly video inspection reports.",
  },
  {
    q: "Are the online rental agreements legally valid in court?",
    a: "Yes, 100%. Our rental agreements are drafted by advocates compliant with the Karnataka Rent Control Act and are officially e-stamped on government-authorized portal with verifiable unique certificate identification numbers and Aadhaar e-Signatures.",
  },
  {
    q: "What is the timeline for BBMP e-Khata registration and BESCOM transfer?",
    a: "e-Khata documentation collection typically begins within 24 hours of your request. Depending on the BBMP zone and document verification status, approval takes between 10 to 20 working days. BESCOM electricity meter transfers are typically completed within 3 to 5 business days.",
  },
  {
    q: "What paints and warranty do you offer under home painting?",
    a: "We use only 100% authentic, sealed containers from Asian Paints (Royale, Apcolite, Tractor Emulsion) and Berger. We provide mechanized dustless sanding, complete floor masking, and a 1-year guarantee against peeling, blistering, and flaking.",
  },
  {
    q: "Can I rent furniture and appliances together on a combo plan?",
    a: "Yes! We offer curated 1 BHK, 2 BHK, and 3 BHK full-home furnishing combos that include living room sofas, dining tables, queen/king beds with memory mattresses, refrigerators, washing machines, and smart TVs with free delivery and assembly.",
  },
  {
    q: "Do you charge any upfront brokerage for buyers searching for new projects?",
    a: "No! For our developer-partnered primary new launches and featured developments (such as Sumadhura, Brigade, Sobha, Poulomi), our advisory and VIP site-visit services are 100% zero brokerage for prospective homebuyers.",
  },
];

const ServicesFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? -1 : idx);
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-12 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-50 text-red-600 border border-red-100 text-xs font-bold uppercase tracking-wider mb-4">
            Got Questions?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-gray-900 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-gray-600 text-base sm:text-lg">
            Everything you need to know about our real estate services, timelines, and guarantees.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="border border-gray-200 rounded-2xl overflow-hidden transition-all duration-200"
              >
                <button
                  onClick={() => toggle(idx)}
                  className="w-full py-5 px-6 sm:px-8 text-left flex items-center justify-between gap-4 bg-gray-50/50 hover:bg-gray-50 transition-colors"
                >
                  <span className="text-base sm:text-lg font-bold text-gray-900">
                    {item.q}
                  </span>
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 ${
                      isOpen
                        ? "bg-red-600 text-white rotate-180"
                        : "bg-gray-200 text-gray-700"
                    }`}
                  >
                    <ChevronDown className="w-4 h-4" />
                  </div>
                </button>

                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="p-6 sm:px-8 sm:pb-6 text-sm sm:text-base text-gray-600 leading-relaxed border-t border-gray-100 bg-white">
                        {item.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesFAQ;
